query getCompanyEmailFunnelsBounceStatistics($input: CompanyEmailFunnelsBounceInput) {
  emailBounceStatistics: getCompanyEmailFunnelsBounceStatistics(input: $input) {
    days {
      date
      softBounce
      hardBounce
    }
    softBounce
    hardBounce
  }
}
